import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { CUISINE_TYPE_NODE_FRAGMENT } from '../fragments'

const REPLACE_CUISINE_TYPE_MUTATION = gql`
  mutation replaceCuisineType($idToReplace: ID!, $replacementId: ID!) {
    replaceCuisineType(
      idToReplace: $idToReplace
      replacementId: $replacementId
    ) {
      results {
        ...CuisineTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${CUISINE_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default REPLACE_CUISINE_TYPE_MUTATION
